export const type_text = 1
export const type_long_text = 2
export const type_image = 5
export const type_radio = 3
export const type_checkbox = 4
export const type_product_type = 7
export const type_name_key_product_type = 'tags' //产品类型
export const type_name_key_cpc = 'cpc' //国家省市
export const type_video = 'video' //国家省市
export const type_name_key_supplier_id = 'supplier_id' //supplier_id


export const mandatory_require = 1
export const mandatory_no_require = 0

//  0：展商、1：采购商 、2 ：展品 、3：展商联系人 4、分会场
//   `type` int(1) DEFAULT NULL COMMENT '0:展商 1:观众 2:展品 3:需求',
export const type_src_supplier = 0
export const type_src_exhibitor = 0
export const type_src_purchaser = 1
export const type_src_exhibits = 2
export const type_src_demand = 3
export const type_src_exhibitor_contact = 3
export const type_src_parallel_sessions = 4

//消息类型
export const messageType_videoCallInvite = "videoCallInvite" //视频邀请
export const messageType_remindOther = "remindOther" //提示邀约邀请
export const messageType_invite = "messageType_invite" //邀请
export const messageType_otherEnterMeeting = "otherEnterMeeting" //贸易配对
// 采购商 ppcgs
// 需求 ppxq
//展商 cgs
//  展品列表  zp
//  展品详情  zpd
export const dom_type_ppcgs = 'ppcgs'
export const dom_type_ppxq = 'ppxq'
export const dom_type_cgs = 'cgs'
export const dom_type_zp = 'zp'
export const dom_type_zpd = 'zpd'

//online 0离线  1在线
export const type_unonline = 0
export const type_online = 1

//预约状态
export const type_reservation_status_submit = 0 // 确定
export const type_reservation_status_waiting = 2 // 待确认
export const type_reservation_status_reject = 5 // 被拒绝
export const type_reservation_status_cancel = 6 // 已取消

//isStart
export const type_isStart_begin = 1 // 开始
export const type_isStart_end = 0 // 结束
export const type_isStart_no_begin = 2 // 未开始

//个人系统通知组
export const personage_system_group = "system_" //个人系统通知组

export const appointment_type_message = {
    "invite": "invite", //邀请
    "remind": "remind", //提醒
    "confirmed": "confirmed",//确认预约通知
    "videoCall": "videoCall", //视频1对1
    "wxVideoCall": "videoCallInvite",
}
export const appointment_type_message_china = {
    "invite": "邀请预约", //邀请
    "remind": "提醒预约", //提醒
    "confirmed": "确认预约通知",//确认预约通知
    "videoCall": "视频邀约",
}


export const CONTRY_LIST="contryList"

// 承若书
export const commitTitle = {
    chinese: '直播活动承诺书',
    english: ''
}
export const commitContentOne = {
    chinese: '本公司参加西安西部文化产业博览会有限公司（以下简称“承办方”）承办的“第十届中国西部文化产业博览会”，并使用承办方免费提供的展会现场同步直播平台，在线展示本公司产品及服务。为保证展会直播活动文明开展，本公司作出如下承诺：',
    english: ''
}
export const commitContentTwo = {
    chinese: '1.本公司发布及直播等一切内容及形式严格遵守中华人民共和国法律法规、政策、以及主办方现行及后续更改和增补的相关要求。',
    english: ''
}
export const commitContentThree = {
    chinese: '2.保证不传播包含法律法规禁止和违反公序良俗的信息内容，且只宣传本公司相关产品和关联企业，不宣传和出现其它相关同行展会信息。',
    english: ''
}
export const commitContentFour = {
    chinese: '3.所宣传之信息及视频符合中国广告法要求，不得从事虚假宣传，夸大混淆等涉嫌不正当竞争之行为。',
    english: ''
}
export const commitContentFive = {
    chinese: '4.发布及直播一切内容和形式严禁售卖假冒伪劣产品，否则，一经查实，主办方有权立即取消直播，且该公司需自行承担相应法律责任及由此引起的所有费用。',
    english: ''
}
export const commitContentSix = {
    chinese: '5.发布及直播一切内容及形式皆已获得相关权利人授权，不涉及对相关权利人的名誉权、隐私权、肖像权等权利的争议，若因本公司直播的行为及内容发生任何争议，由本公司自行处理并承担全部费用。',
    english: ''
}
export const commitContentSeven = {
    chinese: '6.对主办方造成的一切损失（包括但不限于甲方有权要求乙方承担支付第三方的和解金、赔偿金、为解决争议所支付的诉讼费、律师费、差旅费、保全保险费等所有案件费用）将予以全部赔偿。',
    english: ''
}
export const commitContentEight = {
    chinese: '本承诺书自本公司签字之日起生效；适用中华人民共和国法律进行适用和解释，所可能引发之争端由中华人民共和国境内具有管辖权的人民法院进行管辖。',
    english: ''
}
export const commitHeadShenzhen = {
    chinese: '本公司参加广州闻信展览服务有限公司（以下简称“主办方”）主办的“2020深圳国际LED展/灯光音响及智能多媒体展/商显及视听系统集成展/数字标牌展/广告标识展”（以下简称“展会”），并使用主办方免费提供的展会现场全球同步直播平台（链接为：live.LEDChina.com），在线展示本公司产品及服务。为保证展会直播活动文明开展，本公司作出以下承诺：',
    // english: "Our company will participate in CERAMICS CHINA 2021 (hereafter refer to the “Event”) in Guangzhou organized by China Ceramic Industrial Association and Unifair Exhibition Service Co., Ltd. (hereafter refer to the Organizer), and will use the Online Expo platform (link: online.ceramicschina.com.cn) provided by the Organizer to present the Company's products and services online. To ensure the Online Expo activities in the exhibition will be held in a proper way, our company makes the commitments as followed:"
    english: "Our company will participate in CERAMICS CHINA 2022 (hereafter refer to the “Event”) in Guangzhou organized by CCPITV Building Materials Sub-council, China Building Materials Federation and China Building Ceramics & Sanitaryware Association  (hereafter refer to the Organizer), and will use the Online Expo platform (link: online.ceramicschina.net) provided by the Organizer to present the Company's products and services online. To ensure the Online Expo activities in the exhibition will be held in a proper way, our company makes the commitments as followed:"
}
export const commitHeadShangHai = {
    chinese: '本公司参加广州闻信展览服务有限公司（以下简称“主办方”）主办的“2020上海国际广告标识展/数码印花及丝网印刷展/数字标牌展/LED展/商显及视听系统集成展”（以下简称“展会”），并使用主办方免费提供的展会现场全球同步直播平台（链接为：live.SignChinaShow.com），在线展示本公司产品及服务。为保证展会直播活动文明开展，本公司作出以下承诺：',
    // english: "Our company will participate in CERAMICS CHINA 2021 (hereafter refer to the “Event”) in Guangzhou organized by China Ceramic Industrial Association and Unifair Exhibition Service Co., Ltd. (hereafter refer to the Organizer), and will use the Online Expo platform (link: online.ceramicschina.com.cn) provided by the Organizer to present the Company's products and services online. To ensure the Online Expo activities in the exhibition will be held in a proper way, our company makes the commitments as followed:"
    english: "Our company will participate in CERAMICS CHINA 2022 (hereafter refer to the “Event”) in Guangzhou organized by CCPITV Building Materials Sub-council, China Building Materials Federation and China Building Ceramics & Sanitaryware Association  (hereafter refer to the Organizer), and will use the Online Expo platform (link: online.ceramicschina.net) provided by the Organizer to present the Company's products and services online. To ensure the Online Expo activities in the exhibition will be held in a proper way, our company makes the commitments as followed:"
}
export const commitmentList = [
    {
        chinese: '直播的一切内容及形式严格遵守中华人民共和国法律法规、政策、以及主办方的相关要求，不传播包含法律法规禁止和违反公序良俗的信息内容；',
        // english: "All content and forms of Online Expo are strictly in accordance with the laws, regulations, policies of the People's Republic of China and the requirements of the Organizer, and will not broadcast any information which is prohibited by laws and regulations or contrary to public order and good morals;"
        english: "All content and forms of Online Expo are strictly in accordance with the laws, regulations, policies of the People's Republic of China and the requirements of the Organizer, and will not broadcast any information which is prohibited by laws and regulations or contrary to public order and good morals;"
    },
    {
        chinese: "直播的公司所播放之视频只能宣传企业及展品，不得宣传和出现其它相关同行展会信息；且所宣传之信息及视频符合中国广告法要求，不得从事虚假宣传，夸大混淆等涉嫌不正当竞争之行为；直播之一切内容和形式严禁售卖假冒伪劣产品，否则，一经查实，主办方有权立即取消直播，且该公司需自行承担相应法律责任及由此引起的所有费用；",
        // english: "All contents including texts, pictures or video uploaded to the Online Expo can only promote our company and products and must not promote and display any information (such as but not limited to logo/photo/video) from the other related peer exhibitions and/or competitive exhibitions; "
        english: "All contents including texts, pictures or video uploaded to the Online Expo can only promote our company and products and must not promote and display any information (such as but not limited to logo/photo/video) from the other related peer exhibitions and/or competitive exhibitions;"
    },
    {
        chinese: "直播一切内容及形式皆已获得相关权利人授权，不涉及对相关权利人的名誉权、隐私权、肖像权等权利的争议，若因本公司直播的行为及内容发生任何争议，由本公司自行处理并承担全部费用。对主办方闻信公司造成的一切损失将予以全部赔偿；",
        // english: "The promoted information and videos shall comply with the requirements of the Chinese Advertising Law and do not engage in false publicity, and make any exaggeration or confusion or other suspected unfair competition behaviors; "
        english: "The promoted information and videos shall comply with the requirements of the Chinese Advertising Law and do not engage in false publicity, and make any exaggeration or confusion or other suspected unfair competition behaviors;"
    },
    {
        chinese: "本承诺书自本公司签字之日起生效；",
        // english: "All content and forms of the Online Expo strictly prohibited to sell fake and shoddy products. Otherwise, the Organizer has the right to immediately cancel the qualification of our company in Online Expo, and the Company shall undertake the corresponding legal responsibility and all the expenses caused by it if verified;"
        english: "All content and forms of the Online Expo strictly prohibited to sell fake and shoddy products. Otherwise, the Organizer has the right to immediately cancel the qualification of our company in Online Expo, and the Company shall undertake the corresponding legal responsibility and all the expenses caused by it if verified;"
    },
    {
        chinese: "本承诺书自本公司签字之日起生效；",
        // english: "All content and forms of the Online Expo have been authorized by the relevant right holders, and no disputes over the right of reputation, privacy, portrait rights and other rights of the relevant right holders will occur. If there is a rights's dispute during our company's Online Expo, our company will handle it on its own and undertake all relevant costs, and will compensate the Organizer for all losses suffered therefrom;"
        english: "All content and forms of the Online Expo have been authorized by the relevant right holders, and no disputes over the right of reputation, privacy, portrait rights and other rights of the relevant right holders will occur. If there is a rights' s dispute during our company's Online Exhibition, our company will handle it on its own and undertake all relevant costs, and will compensate the Organizer for all losses suffered therefrom;"
    },
    {
        chinese: "本承诺书自本公司签字之日起生效；",
        // english: "This commitment letter shall be applied and interpreted in accordance with the laws of the People's Republic of China, and any disputes that may arise shall be under the jurisdiction of the People's Court which has the jurisdiction;"
        english: "This commitment letter shall be applied and interpreted in accordance with the laws of the People's Republic of China, and any disputes that may arise shall be under the jurisdiction of the People's Court which has the jurisdiction;"
    },
    {
        chinese: "本承诺书适用中华人民共和国法律进行适用和解释，所可能引发之争端由中华人民共和国境内具有管辖权的人民法院进行管辖；",
        // english: "Any behavior of our company's employees who login on the Online Expo and upload any contents and forms of the Online Expo (such as but not limited to logo/photo/video) will mean that our company agree and comply with the full terms indicated in this Commitment Letter."
        english: "Any behavior of our company's employees who login on the Online Exhibition and upload any contents and forms of the Online Expo (such as but not limited to logo/photo/video) will mean that our company agree and comply with the full terms indicated in this Commitment Letter."
    },
    {
        chinese: "本承诺书文本内容若发生争议，以中文版本为准。",
        // english: "The Chinese version of this Commitment Letter shall prevail if there's any dispute over this letter."
        english: "The Chinese version of this Commitment Letter shall prevail if there's any dispute over this letter."
    }
]







// WEBPACK FOOTER //
// ./src/common/constact.js